module.exports = __webpack_public_path__ + "static/media/home_app.caba165d.png";